/* unplugin-vue-components disabled */import { render } from "./RouteTracker.vue?vue&type=template&id=ea188dd2&ts=true"
import script from "./RouteTracker.vue?vue&type=script&lang=ts"
export * from "./RouteTracker.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__